export const FETCH_PROVIDER_INVOICES_REQUEST = "FETCH_PROVIDER_INVOICES_REQUEST";
export const FETCH_PROVIDER_INVOICES_SUCCESS = "FETCH_PROVIDER_INVOICES_SUCCESS";
export const FETCH_PROVIDER_INVOICES_FAILURE = "FETCH_PROVIDER_INVOICES_FAILURE";
